import React, { Component } from 'react';
import { List, Typography, Badge } from 'antd';
import moment from 'moment';
import { isEmpty } from 'lodash';
import chatChannelsItemStyles from './ChatConversationItem.module.css';
import { apiPut } from '../brainApi';
import InitialsAvatar from './InitialsAvatar';
import ConversationQuickActions from './ConversationQuickActions';
import ReplaceEmoji from './Emoji';

const { Text } = Typography;

class ConversationListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isConversationRead: false,
      ticketHistory:
        props.item.baseConversation.channelState.attributes.ticket_history ||
        [],
      readReceipts:
        props.item.baseConversation.channelState.attributes.read_receipts || [],
    };
  }

  componentDidMount() {
    this.setIsConversationRead();
  }

  componentDidUpdate(prevProps) {
    const { ticketHistory, readReceipts } = this.state;
    const {
      selectedConversationSid,
      item: {
        baseConversation,
        baseConversation: {
          channelState: { attributes },
        },
        lastMessage,
      },
    } = this.props;

    // On switching conversations, getting a new message, or read receipts update, check if read
    if (
      prevProps.selectedConversationSid !== selectedConversationSid ||
      prevProps.item.lastMessage !== lastMessage ||
      JSON.stringify(readReceipts) !==
        JSON.stringify(attributes.read_receipts || [])
    ) {
      this.setIsConversationRead();
      this.setState({ readReceipts: attributes.read_receipts || [] });
    }

    // Check for ticket status updates
    if (
      JSON.stringify(ticketHistory) !==
      JSON.stringify(attributes.ticket_history || [])
    ) {
      this.setState({ ticketHistory: attributes.ticket_history });
    }

    // If new message comes in while conversation is selected, update read receipt and mark as read
    if (
      lastMessage !== prevProps.item.lastMessage &&
      baseConversation.sid === selectedConversationSid
    ) {
      apiPut(`/twilio/conversation/${baseConversation.sid}/read-receipt`, {
        markAsUnread: false,
      }).then(this.setIsConversationRead);
    }
  }

  joinClassNames = (classNames) => {
    return classNames.filter(Boolean).join(' ');
  };

  setIsConversationRead = () => {
    const { item, checkIfRead, email } = this.props;
    this.setState({ isConversationRead: checkIfRead(item, email) });
  };

  render() {
    const { isConversationRead } = this.state;

    const {
      item: {
        baseConversation,
        baseConversation: {
          channelState: {
            friendlyName,
            attributes: { ticket_history: ticketHistory },
          },
        },
        lastMessage,
      },
      onChannelClick,
      selectedConversationSid,
      handleTicketUpdate,
      email,
    } = this.props;

    const initialsAvatarColor =
      baseConversation.sid === selectedConversationSid ? '#ffffff' : 'initial';

    const ticketStatus =
      ticketHistory && ticketHistory[ticketHistory.length - 1].status;
    const activeChannel = baseConversation.sid === selectedConversationSid;
    const channelItemClassName = this.joinClassNames([
      chatChannelsItemStyles['conversation-item'],
      activeChannel && chatChannelsItemStyles['conversation-item--active'],
    ]);

    const getDisplayTimestamp = (timestamp) => {
      const messageTimestamp = moment(timestamp);
      const today = moment(new Date());

      // If message is from today, display "Today, h:mm a".
      if (messageTimestamp.isSame(today, 'day')) {
        return messageTimestamp.format('[Today] h:mm a');
      }
      // If within a week, display 3 letter day abbr.
      if (today.diff(messageTimestamp, 'days') < 7) {
        return messageTimestamp.format('ddd h:mm a');
      }
      // If older, "MM/DD/YYYY"
      return messageTimestamp.format('MM/DD/YYYY');
    };

    let lastMessageDetails = '';
    if (!isEmpty(lastMessage)) {
      lastMessageDetails = (
        <div
          className="last-message-details"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
          }}
        >
          <Text
            className={chatChannelsItemStyles['conversation-item-text']}
            ellipsis
          >
            {lastMessage.state.type === 'media'
              ? 'Image'
              : ReplaceEmoji(lastMessage.state.body)}
          </Text>
          <Text
            className={chatChannelsItemStyles['conversation-item-text']}
            style={{ margin: '0 4px' }}
          >
            ·
          </Text>
          <Text
            className={chatChannelsItemStyles['conversation-item-text']}
            style={{ whiteSpace: 'nowrap' }}
          >
            {getDisplayTimestamp(lastMessage.state.timestamp)}
          </Text>
        </div>
      );
    }

    return (
      <List.Item
        key={baseConversation.sid}
        onClick={() => {
          onChannelClick(baseConversation, this.setIsConversationRead);
        }}
        className={channelItemClassName}
      >
        {!isConversationRead && (
          <Badge
            status="processing"
            style={{ position: 'absolute', left: '10px' }}
          />
        )}

        <span style={{ marginRight: '10px' }}>
          <InitialsAvatar name={friendlyName} color={initialsAvatarColor} />
        </span>

        <div className={chatChannelsItemStyles['preview-actions-wrapper']}>
          <div
            className="conversation-preview"
            style={{ width: '100%', overflow: 'hidden' }}
          >
            <div
              className="status-name"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
              }}
            >
              <Text
                ellipsis
                className={chatChannelsItemStyles['conversation-item-text']}
              >
                {baseConversation.friendlyName || baseConversation.sid}
              </Text>
            </div>
            {lastMessageDetails}
          </div>
          {((isConversationRead && !isEmpty(lastMessage)) ||
            ticketStatus !== 'Resolved') && (
            <ConversationQuickActions
              conversationSid={baseConversation.sid}
              email={email}
              handleTicketUpdate={handleTicketUpdate}
              lastMessage={lastMessage}
              ticketHistory={ticketHistory}
              isConversationRead={isConversationRead}
              setIsConversationRead={this.setIsConversationRead}
            />
          )}
        </div>
      </List.Item>
    );
  }
}

export default ConversationListItem;
